import axios from "axios";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
// import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router"; // FIX: Should be react-router-dom
import { AppContext } from "../../AppProvider";
// import Card from "../ui/Card";

// const responsive = {
//   superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 7 },
//   desktop: { breakpoint: { max: 3000, min: 1024 }, items: 5}, // Best is 3 items for normal desktops
//   tablet: { breakpoint: { max: 1024, min: 464 }, items: 3 },
//   mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
// };

const SectoralArea = ({ practice_caption }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { uri } = useContext(AppContext);

  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    axios
      .get(`${uri}practice-areas/`)
      .then((response) => {
        setCardData(response.data);
      })
      .catch((error) => {
        setError(error.message); // Only use error.message for safety
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <span className="loading loading-bars loading-lg"></span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="py-5">
      <div className="w-full flex flex-col items-center justify-center mb-5">
        <Link to="/practice-areas">
        <p className="text-3xl md:text-4xl font-bold bg-gradient-to-tr from-base_900 to-base_500 bg-clip-text text-transparent ">
          Sectoral Presence
        </p>
        </Link>
        <div
          dangerouslySetInnerHTML={{ __html: practice_caption }}
          className="text-center mt-5 px-4 md:px-10"
        />
      </div>

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  gap-10 justify-items-center px-4 "> 
        {cardData.map((card) => (
          <Link key={card.id} to={`/practice-areas/${card.id}`}>
            <div className="min-h-[12rem] min-w-[12rem] max-h-[20rem] max-w-[20rem] relative overflow-hidden rounded-lg shadow-lg">
              <img
                src={card.image}
                alt={card.name}
                className="object-cover h-full w-full"
              />
              <div className="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full bg-black bg-opacity-50 text-white p-4">
                <h2 className="text-lg font-semibold text-center">{card.name.length > 40 ? card.name.substring(0, 40) + "..." : card.name}</h2>
              
                <button className="h-12 px-4 py-2 mt-6 text-black bg-white border rounded-2xl hover:shadow-lg">
                  View Details
                </button>
              </div>
            </div>
          </Link>
        ))}

      </div>
    </div>
  );
};

SectoralArea.propTypes = {
  practice_caption: PropTypes.string.isRequired,
};

export default SectoralArea;










    {/* <Carousel
          swipeable
          draggable
          showDots={false}
          responsive={responsive}
          infinite
          autoPlay
          autoPlaySpeed={3000} // 3 seconds per slide
          keyBoardControl
          transitionDuration={500} // smooth slide
          containerClass="carousel-container"
          // dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {cardData.map((card) => (
            <Link key={card.id} to={`/practice-areas/${card.id}`}>
              <Card
                title={card.name}
                description={card.introduction}
                id={card.id}
                photo={card.image}
                logo={card.logo}
              />
            </Link>
          ))}
        </Carousel> */}
        // </Carousel> */}